{
  "version": 1,
  "asset_id": "99a30460-cb88-405c-9a0d-e484bae2fc9e",
  "project_id": "f9ca952a-2109-492f-a7b0-0345b2dfa2e1",
  "url": "/__l5e/assets-v1/99a30460-cb88-405c-9a0d-e484bae2fc9e/forage-kpmg-audit-cert.jpg",
  "r2_key": "a/v1/f9ca952a-2109-492f-a7b0-0345b2dfa2e1/99a30460-cb88-405c-9a0d-e484bae2fc9e/forage-kpmg-audit-cert.jpg",
  "original_filename": "forage-kpmg-audit-cert.jpg",
  "size": 112297,
  "content_type": "image/jpeg",
  "created_at": "2026-07-22T11:39:38Z"
}
